import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from '../searchV2.scss';

const MobileModal = ({
    isOpen,
    onClose,
    title,
    children,
    onApply,
    titleClassName,
    showFooter,
    showCancelButton,
    'data-testid': dataTestId,
}) => {
    useEffect(() => {
        if (isOpen) {
            // Prevent background page scroll when modal is open
            document.body.style.overflow = 'hidden';

            return () => {
                document.body.style.overflow = 'unset';
            };
        }
    }, [isOpen]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);

            return () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [isOpen, onClose]);

    if (!isOpen) {
        return null;
    }

    const handleApply = () => {
        if (onApply) {
            onApply();
        }
        onClose();
    };

    const baseTestId = dataTestId || 'mobile-modal';

    return ReactDOM.createPortal(
        <div
            className={styles.mobileModal}
            data-testid={baseTestId}
        >
            {/* Header */}
            <div className={styles.mobileModalHeader}>
                <div onClick={onClose} className={styles.mobileModalCloseButton} data-testid={`${baseTestId}.close-btn`}>
                    <img src="/img/icons/close-icon-lg.svg" alt="Close" />
                </div>
                <div className={`${styles.mobileModalTitle} ${titleClassName || ''}`} data-testid={`${baseTestId}.title`}>
                    {title}
                </div>
                <div className={styles.mobileModalSpacer} /> {/* Spacer for centering */}
            </div>

            {/* Body */}
            <div className={styles.mobileModalBody}>
                <div className={`mobile-modal-content ${styles.mobileModalContent}`}>
                    {children}
                </div>
            </div>

            {showFooter && (
                <div className={styles.mobileModalFooter}>
                    <button
                        type="button"
                        onClick={handleApply}
                        className={styles.applyButton}
                        data-testid={`${baseTestId}.apply-btn`}
                    >
                        APPLY
                    </button>
                    {showCancelButton && (
                        <button
                            type="button"
                            onClick={onClose}
                            className={styles.cancelButton}
                            data-testid={`${baseTestId}.cancel-btn`}
                        >
                            CANCEL
                        </button>
                    )}
                </div>
            )}
        </div>,
        document.body,
    );
};

MobileModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    onApply: PropTypes.func,
    titleClassName: PropTypes.string,
    showFooter: PropTypes.bool,
    showCancelButton: PropTypes.bool,
    'data-testid': PropTypes.string,
};

MobileModal.defaultProps = {
    onApply: null,
    titleClassName: '',
    showFooter: true,
    showCancelButton: true,
    'data-testid': null,
};

export default MobileModal;
